import React, { useContext, useEffect } from "react";
import "./InformacionAcreditados.css";
const InformacionAcreditados = () => {
  return (
    <div className="InformacionAcreditados__container">
      <div className="AcreditadoInfo_container ">
        <div className="AcreditadoInfo_Imgcontainer">
          {/* <KTSVG path={"/img/Icons/defaultUser.svg"} className={`svg-icon`} /> */}
        </div>
        <div className="AcreditadoInfo_InfoContainer">
          <div className="AcreditadoInfo_Name">
            {" "}
            {/* ({infoUs.CarGclave}){infoUs.GesRazonSocial}*/}
          </div>
          <div className="AcreditadoInfo_Fields">
            <div className="AcreditadoInfo_GestorType">
              {/* <KTSVG path={"/img/Icons/defaultUser.svg"} className={`svg-icon`} /> */}
              <span className="svg-icon svg-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mh-50px"
                >
                  <path
                    opacity="0.3"
                    d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z"
                    fill="black"
                  ></path>
                  <path
                    d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z"
                    fill="black"
                  ></path>
                </svg>
              </span>
              Grado
            </div>
            <div className="AcreditadoInfo_Ciudad">
              {/* <KTSVG path={"/img/Icons/Maps.svg"} className={`svg-icon`} /> */}
              <span className="svg-icon svg-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mh-50px"
                >
                  <path
                    opacity="0.3"
                    d="M18.0624 15.3454L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3454C4.56242 13.6454 3.76242 11.4452 4.06242 8.94525C4.56242 5.34525 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24525 19.9624 9.94525C20.0624 12.0452 19.2624 13.9454 18.0624 15.3454ZM13.0624 10.0453C13.0624 9.44534 12.6624 9.04534 12.0624 9.04534C11.4624 9.04534 11.0624 9.44534 11.0624 10.0453V13.0453H13.0624V10.0453Z"
                    fill="black"
                  ></path>
                  <path
                    d="M12.6624 5.54531C12.2624 5.24531 11.7624 5.24531 11.4624 5.54531L8.06241 8.04531V12.0453C8.06241 12.6453 8.46241 13.0453 9.06241 13.0453H11.0624V10.0453C11.0624 9.44531 11.4624 9.04531 12.0624 9.04531C12.6624 9.04531 13.0624 9.44531 13.0624 10.0453V13.0453H15.0624C15.6624 13.0453 16.0624 12.6453 16.0624 12.0453V8.04531L12.6624 5.54531Z"
                    fill="black"
                  ></path>
                </svg>
              </span>
              Escuela
            </div>
            <div className="AcreditadoInfo_Ciudad">
              {/* <KTSVG path={"/img/Icons/Maps.svg"} className={`svg-icon`} /> */}
              Asignacion
            </div>
            <div className="AcreditadoInfo_Email">
              {/* <KTSVG path={"/img/Icons/Email.svg"} className={`svg-icon`} /> 
            {infoUs.GesEmail}*/}
              <span className="svg-icon svg-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="mh-50px"
                >
                  <path
                    opacity="0.3"
                    d="M21 18H3C2.4 18 2 17.6 2 17V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V17C22 17.6 21.6 18 21 18Z"
                    fill="black"
                  ></path>
                  <path
                    d="M11.4 13.5C11.8 13.8 12.3 13.8 12.6 13.5L21.6 6.30005C21.4 6.10005 21.2 6 20.9 6H2.99998C2.69998 6 2.49999 6.10005 2.29999 6.30005L11.4 13.5Z"
                    fill="black"
                  ></path>
                </svg>
              </span>
              Email
            </div>
          </div>
        </div>
        <div className="flex-grow-1 ">
          <div className="d-flex flex-wrap flex-stack display-grid">
            <div className="d-flex flex-column flex-grow-1 pe-8">
              <div className="d-flex flex-wrap">
                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 One">
                  <div className="d-flex align-items-center">
                    <span className="svg-icon svg-icon-3 svg-icon-success me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          opacity="0.5"
                          x="13"
                          y="6"
                          width="13"
                          height="2"
                          rx="1"
                          transform="rotate(90 13 6)"
                          fill="black"
                        ></rect>
                        <path
                          d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z"
                          fill="black"
                        ></path>
                      </svg>
                    </span>

                    <div
                      className="fs-2 fw-bolder counted"
                      data-kt-countup="true"
                      data-kt-countup-value="4500"
                      data-kt-countup-prefix="$"
                    >
                      $4,500
                    </div>
                  </div>

                  <div className="fw-bold fs-6 text-gray-400">Earnings</div>
                </div>

                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 two">
                  <div className="d-flex align-items-center">
                    <span className="svg-icon svg-icon-3 svg-icon-danger me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          opacity="0.5"
                          x="11"
                          y="18"
                          width="13"
                          height="2"
                          rx="1"
                          transform="rotate(-90 11 18)"
                          fill="black"
                        ></rect>
                        <path
                          d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z"
                          fill="black"
                        ></path>
                      </svg>
                    </span>

                    <div
                      className="fs-2 fw-bolder counted"
                      data-kt-countup="true"
                      data-kt-countup-value="80"
                    >
                      80
                    </div>
                  </div>

                  <div className="fw-bold fs-6 text-gray-400">Projects</div>
                </div>

                <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 three">
                  <div className="d-flex align-items-center">
                    <span className="svg-icon svg-icon-3 svg-icon-success me-2">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          opacity="0.5"
                          x="13"
                          y="6"
                          width="13"
                          height="2"
                          rx="1"
                          transform="rotate(90 13 6)"
                          fill="black"
                        ></rect>
                        <path
                          d="M12.5657 8.56569L16.75 12.75C17.1642 13.1642 17.8358 13.1642 18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25L12.7071 5.70711C12.3166 5.31658 11.6834 5.31658 11.2929 5.70711L5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75C6.16421 13.1642 6.83579 13.1642 7.25 12.75L11.4343 8.56569C11.7467 8.25327 12.2533 8.25327 12.5657 8.56569Z"
                          fill="black"
                        ></path>
                      </svg>
                    </span>

                    <div
                      className="fs-2 fw-bolder counted"
                      data-kt-countup="true"
                      data-kt-countup-value="60"
                      data-kt-countup-prefix="%"
                    >
                      %60
                    </div>
                  </div>

                  <div className="fw-bold fs-6 text-gray-400">Success Rate</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InformacionAcreditados;
